module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"17.2 14.7 24 24.3\"><path d=\"M37.2 22.8c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1c0-.6-.5-1.1-1.1-1.1zM24.8 31h8v1h-8zM24.8 33h5v1h-5z\"/><path d=\"M37.2 20v-5.3h-16V20h-4v13h4v6h8c5.1 0 8-3 8-6h4V20h-4zm-14-3.3h12V20h-12v-3.3zM35.6 33c0 2.2-3.1 1-3.1 1s.2 3.4-3.3 3.4h-6.4v-8.8h12.8V33zm3.6-2h-2v-4h-16v4h-2v-9h20v9z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/print.svg
// module id = 88
// module chunks = 0